// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'plus-line-above-below';

export const Component = () => (
  <path d='M0 1V0h25v1H0zm0 24v-1h25v1H0zm11.89-6.26h.958v-5.892h5.891v-.957h-5.89V6h-.958v5.89H6v.958h5.89v5.891z' />
);

export const viewBox = '0 0 25 25';
